import { alpha } from "@mui/material/styles";

// A collapsed row (a formación, an experiencia) painted with the colour of the
// most serious chip it carries, so its state reads without looking for the
// chip: rejected / someone else's document (red) over missing support
// (orange) over waiting for review (blue) over validated (green).
const TONE_PRIORITY = ["error", "warning", "info", "success"];

// The most serious palette colour among the chips' `color` props, or null.
export function chipsTone(chips) {
  const colors = (Array.isArray(chips) ? chips : [chips])
    .filter(Boolean)
    .map((c) => c && c.props && c.props.color);
  return TONE_PRIORITY.find((t) => colors.includes(t)) || null;
}

// Background + left rail for the row, and its hover shade.
export function toneRowSx(tone) {
  if (!tone) return { "&:hover": { bgcolor: "action.hover" } };
  return {
    bgcolor: (t) => alpha(t.palette[tone].main, 0.1),
    boxShadow: (t) => `inset 4px 0 0 ${t.palette[tone].main}`,
    "&:hover": { bgcolor: (t) => alpha(t.palette[tone].main, 0.18) },
  };
}
